import React from 'react'
import MaterialTable from '@material-table/core'
import { withTranslation } from 'react-i18next'
import HeaderWithExportOptions from 'components/HeaderWithExportOptions'
import Filter from 'components/Filter'
import { Typography } from '@mui/material'
import { previewModal } from 'store/slices/miscSlice'
import { useDispatch } from 'react-redux'
// import RedemptionDetails from './RedemptionDetails'
import Status from 'components/Status'
import ViewMoreBtn from 'components/viewMoreBtn'
import Spinner from 'components/Spinner'
import useSWR from 'swr'
import { CSV } from 'components/CSV'
import TablePaginationDemo from 'components/Paginator'
import RedemptionDetails from './RedemptionDetails'

export default withTranslation()(function Table({ t, data = [] }) {
  const dispatch = useDispatch()
  const { datas } = useSWR('accounts/balances')
  const cellStyle = {
    //styleName: Type/Android/16 Regular;
    fontFamily: 'HelveticaNeue',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px',
    letterSpacing: '0em',
    textAlign: 'left',
    color: '#657585'
  }
  const head = ['Amount', 'Action-By', 'Email', 'Phone', 'Date', 'Status']
  const rest = data?.data?.map(y => [y?.gross_amount, y?.username, y?.email, y?.phone, y?.date, y?.status])
  const csvData = rest ? [head, ...rest] : []
  // console.log(data)
  return (
    <>
      <HeaderWithExportOptions
        // title={}
        title={<div className='font-[700] font-[24px]'>       <Typography fontSize={'32px'} color='#05213D' fontWeight={'700'}>NGN {datas?.data?.find(x => x.type === 'credit').balance}</Typography> {t('redemption.title')}</div>}

        exportOptions={[
          {
            name: t('settlements.table.filter'),
            Content: () => <>
              <Filter page='redemption-vault' />
            </>,
            click: 'filter'
          },
          {
            name: t('transaction.table.export_csv'),
            Content: () => <CSV fileName='redemption-vault.csv' csvData={csvData} />,
            click: 'export'
          }
        ]}
      />

      {data?.data ? <MaterialTable
        columns={[
          {
            title: t('redemption.table.amount'), field: 'amount', render: (data) => <Typography sx={{ ...cellStyle }}>
              {data.transaction === 'credit' && data.coins_gained} {data.transaction === 'debit' && data.gross_amount}
            </Typography>
          },
          { title: t('redemption.table.type'), field: 'type', render: (data) => <Typography sx={{ ...cellStyle }}>{data.transaction}</Typography> },
          { title: 'Action By', field: 'customer', render: (data) => <Typography sx={{ ...cellStyle }}>{data.username}</Typography> },
          { title: 'Customer email', field: 'customer_email', render: (data) => <Typography sx={{ ...cellStyle }}>{data.email}</Typography> },
          { title: 'Phone', field: 'reference', render: (data) => <Typography sx={{ ...cellStyle }}>{data.phone}</Typography> },
          { title: t('redemption.table.date'), field: 'date', render: (data) => <Typography sx={{ ...cellStyle }}>{data.date}</Typography> },
          {
            title: t('redemption.table.status'), field: 'status', render: (data) => {
              return (data.status === 'completed' ? <Status text={data.status} color={'green'} bg={'rgba(52, 199, 89, 0.2)'} /> : (
                data.status === 'pending' ? <Status text={data.status} color={'#F2994A'} bg={'rgba(242, 153, 74, 0.2)'} /> :
                  <Status text={data.status} color={'#FF0000'} bg={'rgba(255, 0, 0, 0.2)'} />)
              )
            }
          }
        ]}
        actions={[
          {
            icon: ''
          }
        ]}
        options={{
          search: "",
          actionsColumnIndex: -1,
          headerStyle: {
            fontWeight: 'bolder',
            color: '#657585',
            fontFamily: 'Helvetica Neue',
            fontSize: '14px'
          },
          pageSize: data?.per_page

        }}
        localization={{
          header: {
            actions: ""
          },
          body: {
            emptyDataSourceMessage: data?.length === 0 ? 'No records to display' : <Spinner />
          }
        }}
        data={data?.data}
        title=''
        onRowClick={(_,data) => {
                dispatch(previewModal({
                  title: t('redemption.redemptiondetails'),
                  content: () => <RedemptionDetails data={data} />
                }))
              }}
        // icons={Icons}
        components={{
          // Toolbar: () => (
          //   <HeaderWithExportOptions
          //     title={t('redemption.title')}
          //     exportOptions={[a
          //       {
          //         name: t('settlements.table.filter'),
          //         Content: () => <>
          //           <Filter />
          //         </>
          //       },
          //       {
          //         name: t('transaction.table.export_csv')
          //       }
          //     ]}
          //   />
          // ),

          Action: ({ data }) => (
            <>
              <ViewMoreBtn className='hidden' click={() => {
                dispatch(previewModal({
                  title: t('redemption.redemptiondetails'),
                  content: () => <RedemptionDetails data={data} />
                }))
              }} />
            </>
          ),

          Pagination: () => (<TablePaginationDemo {...data} />)

        }}
      /> : <Spinner />}
    </>
  )
})